enum ModerationEvaluation {
  ApprovalRequiredAdminAllow = 'ApprovalRequiredAdminAllow',
  ApprovalRequiredBlock = 'ApprovalRequiredBlock',
  CustomAutoAllow = 'CustomAutoAllow',
  CustomAutoBlock = 'CustomAutoBlock',
  ManualAllow = 'ManualAllow',
  ManualBlock = 'ManualBlock'
}
export default ModerationEvaluation
